export default "__VITE_ASSET__CocP9m9t__";